<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_5244_37360)">
        <path d="M12.042 22C6.52799 22 2.04199 17.514 2.04199 12C2.04199 6.486 6.52799 2 12.042 2C17.556 2 22.042 6.486 22.042 12C22.042 17.514 17.556 22 12.042 22ZM12.042 4C7.63099 4 4.04199 7.589 4.04199 12C4.04199 16.411 7.63099 20 12.042 20C16.453 20 20.042 16.411 20.042 12C20.042 7.589 16.453 4 12.042 4Z" fill="#80919F"/>
        <path d="M16.749 8.70697L15.334 7.29297L12.042 10.586L8.74898 7.29297L7.33398 8.70697L10.627 12L7.33398 15.293L8.74898 16.707L12.042 13.415L15.334 16.707L16.749 15.293L13.456 12L16.749 8.70697Z" fill="#80919F"/>
    </g>
    <defs>
        <clipPath id="clip0_5244_37360">
            <rect width="24" height="24" fill="white"/>
        </clipPath>
    </defs>
</svg>
